import baseapi from "../baseAPI";

export const NotificationListAPI = async (setNotifications, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/team/notifications?page=" + currentPage + "&per_page=" + perpagedata);

        console.log("Data got successfully", response.data.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setNotifications(response.data.data.data);
        setLoading(false);

        if(response.data.data.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const NotificationFilterListAPI = async (setNotifications, setLoading, currentPage, perpagedata, setPageCount, filtertype, filterparams) =>
{
    setLoading(true);

    let txtsearchparam = "";

    if(filterparams !== "" && filterparams !== null && filterparams !== undefined)
    {
        txtsearchparam = `?${filterparams.toString()}`;
    }
    else
    {
        txtsearchparam = "?page=" + currentPage + "&per_page=" + perpagedata;
    }

    try
    {
        const response = await baseapi.get("/api/team/notifications/" + filtertype + txtsearchparam);

        //console.log("Data got successfully", response.data.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setNotifications(response.data.notifications.data);
        setLoading(false);

        if(response.data.notifications.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.notificationcount / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    };
}


